import { RootReducer } from 'types/store';

export const selectCurrentUser = (state: RootReducer) => state.user;

export const selectUserFeatures = (state: RootReducer) => state.user.features;

export const selectIsMobileUser = (state: RootReducer) => state.user.is_mobile_user;
